import * as React from 'react'

const FogIcon = props => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5224 15H3.19242C2.17742 15 1.35742 14.18 1.35742 13.165V2.835C1.35742 1.82 2.17742 1 3.19242 1H13.5224C14.5374 1 15.3574 1.82 15.3574 2.835V13.165C15.3574 14.18 14.5374 15 13.5224 15Z"
      fill="url(#paint0_linear_27536_46188)"
    />
    <path
      d="M13.5224 15H3.19242C2.17742 15 1.35742 14.18 1.35742 13.165V2.835C1.35742 1.82 2.17742 1 3.19242 1H13.5224C14.5374 1 15.3574 1.82 15.3574 2.835V13.165C15.3574 14.18 14.5374 15 13.5224 15Z"
      fill="url(#paint1_radial_27536_46188)"
    />
    <g filter="url(#filter0_i_27536_46188)">
      <path
        d="M13.5224 1H10.6374C8.68242 2.055 7.35742 4.125 7.35742 6.5L15.3574 10.3438V2.835C15.3574 1.825 14.5374 1 13.5224 1Z"
        fill="url(#paint2_radial_27536_46188)"
      />
    </g>
    <path
      d="M3.81242 1H3.19242C2.17742 1 1.35742 1.82 1.35742 2.835V6.5H6.85742C6.85742 4.18 5.63742 2.15 3.81242 1Z"
      fill="url(#paint3_radial_27536_46188)"
    />
    <path
      d="M3.81242 1H3.19242C2.17742 1 1.35742 1.82 1.35742 2.835V6.5H6.85742C6.85742 4.18 5.63742 2.15 3.81242 1Z"
      fill="url(#paint4_radial_27536_46188)"
    />
    <g filter="url(#filter1_i_27536_46188)">
      <path
        d="M9.02828 14.3359C12.157 14.3359 14.6933 11.7996 14.6933 8.67085C14.6933 5.54215 12.157 3.00586 9.02828 3.00586C5.89958 3.00586 3.36328 5.54215 3.36328 8.67085C3.36328 11.7996 5.89958 14.3359 9.02828 14.3359Z"
        fill="url(#paint5_radial_27536_46188)"
      />
      <path
        d="M9.02828 14.3359C12.157 14.3359 14.6933 11.7996 14.6933 8.67085C14.6933 5.54215 12.157 3.00586 9.02828 3.00586C5.89958 3.00586 3.36328 5.54215 3.36328 8.67085C3.36328 11.7996 5.89958 14.3359 9.02828 14.3359Z"
        fill="url(#paint6_radial_27536_46188)"
      />
      <path
        d="M9.02828 14.3359C12.157 14.3359 14.6933 11.7996 14.6933 8.67085C14.6933 5.54215 12.157 3.00586 9.02828 3.00586C5.89958 3.00586 3.36328 5.54215 3.36328 8.67085C3.36328 11.7996 5.89958 14.3359 9.02828 14.3359Z"
        fill="url(#paint7_radial_27536_46188)"
      />
    </g>
    <g filter="url(#filter2_i_27536_46188)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.35692 15H3.19242C2.17742 15 1.35742 14.18 1.35742 13.165V5.305C1.90742 5.11 2.49242 5 3.10742 5C6.00742 5 8.35742 7.35 8.35742 10.25C8.35742 10.865 8.24742 11.45 8.05242 12L6.35692 15Z"
        fill="url(#paint8_radial_27536_46188)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.35692 15H3.19242C2.17742 15 1.35742 14.18 1.35742 13.165V5.305C1.90742 5.11 2.49242 5 3.10742 5C6.00742 5 8.35742 7.35 8.35742 10.25C8.35742 10.865 8.24742 11.45 8.05242 12L6.35692 15Z"
        fill="url(#paint9_radial_27536_46188)"
      />
    </g>
    <g filter="url(#filter3_i_27536_46188)">
      <path
        d="M9.93555 15H13.5221C14.5371 15 15.3571 14.18 15.3571 13.165V8.5C13.1471 8.5 11.3571 10.29 11.3571 12.5L9.93555 15Z"
        fill="url(#paint10_radial_27536_46188)"
      />
      <path
        d="M9.93555 15H13.5221C14.5371 15 15.3571 14.18 15.3571 13.165V8.5C13.1471 8.5 11.3571 10.29 11.3571 12.5L9.93555 15Z"
        fill="url(#paint11_radial_27536_46188)"
      />
    </g>
    <g filter="url(#filter4_i_27536_46188)">
      <path
        d="M8.35742 9.5C5.33242 9.5 2.87242 11.945 2.85742 14.97C2.96742 14.99 3.07742 15 3.19242 15H13.5224C13.6374 15 13.7474 14.99 13.8574 14.97C13.8424 11.945 11.3874 9.5 8.35742 9.5Z"
        fill="url(#paint12_radial_27536_46188)"
      />
      <path
        d="M8.35742 9.5C5.33242 9.5 2.87242 11.945 2.85742 14.97C2.96742 14.99 3.07742 15 3.19242 15H13.5224C13.6374 15 13.7474 14.99 13.8574 14.97C13.8424 11.945 11.3874 9.5 8.35742 9.5Z"
        fill="url(#paint13_linear_27536_46188)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_27536_46188"
        x="7.35742"
        y="1"
        width="8.1"
        height="9.34375"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.1" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.882353 0 0 0 0 0.878431 0 0 0 0 0.882353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_27536_46188"
        />
      </filter>
      <filter
        id="filter1_i_27536_46188"
        x="3.36328"
        y="3.00586"
        width="11.4301"
        height="11.3301"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.1" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.882353 0 0 0 0 0.878431 0 0 0 0 0.882353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_27536_46188"
        />
      </filter>
      <filter
        id="filter2_i_27536_46188"
        x="1.35742"
        y="5"
        width="7.1"
        height="10"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.1" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.882353 0 0 0 0 0.878431 0 0 0 0 0.882353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_27536_46188"
        />
      </filter>
      <filter
        id="filter3_i_27536_46188"
        x="9.93555"
        y="8.5"
        width="5.52188"
        height="6.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.1" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.882353 0 0 0 0 0.878431 0 0 0 0 0.882353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_27536_46188"
        />
      </filter>
      <filter
        id="filter4_i_27536_46188"
        x="2.85742"
        y="9.5"
        width="11.1"
        height="5.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.1" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.882353 0 0 0 0 0.878431 0 0 0 0 0.882353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_27536_46188"
        />
      </filter>
      <linearGradient
        id="paint0_linear_27536_46188"
        x1="8.35742"
        y1="1"
        x2="8.35742"
        y2="3.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDEDED" />
        <stop offset="1" stop-color="#E6E6E6" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.35816 3.90636) rotate(-147.482) scale(2.9648)"
      >
        <stop offset="0.218" stop-color="#DDDDDD" />
        <stop offset="1" stop-color="#DDDDDD" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.9824 2.0625) rotate(129.083) scale(7.9309 6.79035)"
      >
        <stop stop-color="#FCFCFC" />
        <stop offset="1" stop-color="#E4E4E4" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.97158 2.73176) rotate(130.888) scale(3.21509 2.83605)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#EEEEEE" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.12291 5.40623) rotate(-103.925) scale(1.94787 2.96657)"
      >
        <stop offset="0.175" stop-color="#E5E5E5" />
        <stop offset="1" stop-color="#E5E5E5" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.4521 4.5008) rotate(124.276) scale(7.89035)"
      >
        <stop offset="0.258" stop-color="white" />
        <stop offset="1" stop-color="#E9E9E9" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.816 11.1507) rotate(-112.286) scale(2.41518)"
      >
        <stop stop-color="#E3E3E3" />
        <stop offset="1" stop-color="#E3E3E3" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.0779 7.38697) rotate(-163.083) scale(7.12595 7.21635)"
      >
        <stop offset="0.683" stop-color="#E2E2E2" stop-opacity="0" />
        <stop offset="1" stop-color="#E2E2E2" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.43242 7.089) rotate(116.46) scale(9.28445 16.6414)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#EAEAEA" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.23086 12.8936) rotate(133.418) scale(3.69094 2.42735)"
      >
        <stop offset="0.267" stop-color="#DEDEDE" />
        <stop offset="1" stop-color="#DEDEDE" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.1235 9.47967) rotate(114.066) scale(4.28137 4.40889)"
      >
        <stop stop-color="#F7F7F7" />
        <stop offset="1" stop-color="#E3E3E3" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.9086 15.4765) rotate(-75.715) scale(3.84542 3.20742)"
      >
        <stop stop-color="#EDEDED" />
        <stop offset="1" stop-color="#EDEDED" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_27536_46188"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.2592 10.4701) rotate(128.726) scale(7.25455 7.69325)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#E5E5E5" />
      </radialGradient>
      <linearGradient
        id="paint13_linear_27536_46188"
        x1="8.13992"
        y1="16.3875"
        x2="8.13992"
        y2="14.148"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ECECEC" />
        <stop offset="1" stop-color="#ECECEC" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default FogIcon
